export default {
  "vueform": {
    "elements": {
      "list": {
        "add": "+ Addieren",
        "remove": "&times;"
      },
      "file": {
        "defaultName": "File",
        "dndTitle": "File hochladen",
        "dndDescription": "File ablegen oder zum Hochladen hier klicken",
        "removeConfirm": "Durch das Entfernen Files wird diese endgültig gelöscht. Sind Sie sicher, dass Sie fortfahren?",
        "select": "File auswählen",
        "upload": "Hochladen"
      },
      "multifile": {
        "uploadButton": "Files hochladen",
        "dndTitle": "Files hochladen",
        "dndDescription": "File ablegen oder zum Hochladen hier klicken"
      },
      "gallery": {
        "uploadButton": "Bilder hochladen",
        "dndTitle": "Bilder hochladen",
        "dndDescription": "Bild ablegen oder zum Hochladen hier klicken"
      },
      "phone": {
        "ariaLabel": "Wählen Sie ein Land"
      },
      "signature": {
        "type": "Tippen",
        "draw": "Zeichnen",
        "upload": "Hochladen",
        "font": "Schriftart auswählen",
        "fontPlaceholder": "Ihr Name",
        "placeholder": "Hier unterschreiben",
        "unsupportedFormat": "Nicht unterstütztes Dateiformat. Akzeptierte Erweiterungen sind: :extensions",
        "maxSizeError": "Maximale Dateigröße beträgt :max KB",
        "imgAlt": "Unterschrift",
        "imgTitle": "Unterschrift",
        "undo": "Rückgängig",
        "redo": "Wiederherstellen",
        "dnd": "Ziehen Sie ein Bild hierher oder",
        "uploadButton": "Bild auswählen",
        "modeSelectorAriaLabel": "Signaturmodus auswählen",
        "fontSelectorAriaLabel": "Schriftart auswählen",
        "wrapperAriaLabel": "Unterschriftseingabe",
        "inputAriaLabel": "Geben Sie hier Ihre Unterschrift ein",
        "padAriaLabel": "Zeichnen Sie Ihre Unterschrift in das Feld. Bitten Sie um Hilfe, wenn Sie diese benötigen.",
        "clearAriaLabel": "Unterschrift löschen",
        "colorAriaLabel": "Farbe auswählen: "
      }
    },
    "steps": {
      "finish": "Beenden",
      "next": "Nächste",
      "previous": "Früher"
    },
    "editor": {
      "acceptedMimesError": "Accepted mimes are: :mimes",
      "acceptedExtensionsError": "Accepted extenions are: :extensions",
      "acceptedMimes": "Akzeptierte mimes sind: :mimes",
      "acceptedExtensions": "Akzeptierte extenions sind: :extensions"
    },
    "datepicker": {
      "weekdays": {
        "shorthand": [
          "So",
          "Mo",
          "Di",
          "Mi",
          "Do",
          "Fr",
          "Sa"
        ],
        "longhand": [
          "Sonntag",
          "Montag",
          "Dienstag",
          "Mittwoch",
          "Donnerstag",
          "Freitag",
          "Samstag"
        ]
      },
      "months": {
        "shorthand": [
          "Jan",
          "Feb",
          "Mär",
          "Apr",
          "Mai",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Okt",
          "Nov",
          "Dez"
        ],
        "longhand": [
          "Januar",
          "Februar",
          "März",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Dezember"
        ]
      },
      "daysInMonth": [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
      ],
      "firstDayOfWeek": 1,
      "ordinal": function () {
        return '';
      },
      "rangeSeparator": " bis ",
      "weekAbbreviation": "KW",
      "scrollTitle": "Zum Ändern scrollen",
      "toggleTitle": "Zum Umschalten klicken",
      "amPM": [
        "AM",
        "PM"
      ],
      "yearAriaLabel": "Year",
      "monthAriaLabel": "Month",
      "hourAriaLabel": "Hour",
      "minuteAriaLabel": "Minute"
    },
    "dateFormats": {
      "datetimeSeconds24": "DD.MM.YYYY HH:mm:ss",
      "datetimeSeconds12": "DD.MM.YYYY hh:mm:ss a",
      "datetime24": "DD.MM.YYYY HH:mm",
      "datetime12": "DD.MM.YYYY hh:mm a",
      "timeSeconds24": "HH:mm:ss",
      "timeSeconds12": "hh:mm:ss a",
      "time24": "HH:mm",
      "time12": "hh:mm a",
      "date": "DD.MM.YYYY"
    },
    "multiselect": {
      "multipleLabelOne": "1 option ausgewählt",
      "multipleLabelMore": ":options optionen ausgewählt",
      "noResults": "Keine Optionen gefunden",
      "noOptions": "Liste ist leer."
    },
    "defaultMessage": "Ungültiges Feld",
    "a11y": {
      "file": {
        "description": "Press Backspace to remove"
      },
      "list": {
        "remove": "Remove item button"
      }
    },
    "countries": {
      "AF": "Afghanistan",
      "AL": "Albanien",
      "DZ": "Algerien",
      "AS": "Amerikanisch-Samoa",
      "AD": "Andorra",
      "AO": "Angola",
      "AI": "Anguilla",
      "AG": "Antigua und Barbuda",
      "AR": "Argentinien",
      "AM": "Armenien",
      "AW": "Aruba",
      "AC": "Ascension Island",
      "AU": "Australien",
      "AT": "Österreich",
      "AZ": "Aserbaidschan",
      "BS": "Bahamas",
      "BH": "Bahrain",
      "BD": "Bangladesch",
      "BB": "Barbados",
      "BY": "Weißrussland",
      "BE": "Belgien",
      "BZ": "Belize",
      "BJ": "Benin",
      "BM": "Bermuda",
      "BT": "Bhutan",
      "BO": "Bolivien",
      "BA": "Bosnien und Herzegowina",
      "BW": "Botswana",
      "BR": "Brasilien",
      "IO": "Britisches Territorium im Indischen Ozean",
      "VG": "Britische Jungferninseln",
      "BN": "Brunei",
      "BG": "Bulgarien",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "KH": "Kambodscha",
      "CM": "Kamerun",
      "CA": "Kanada",
      "CV": "Kap Verde",
      "BQ": "Karibische Niederlande",
      "KY": "Kaimaninseln",
      "CF": "Zentralafrikanische Republik",
      "TD": "Tschad",
      "CL": "Chile",
      "CN": "China",
      "CO": "Kolumbien",
      "KM": "Komoren",
      "CG": "Kongo-Brazzaville",
      "CD": "Kongo-Kinshasa",
      "CK": "Cookinseln",
      "CR": "Costa Rica",
      "CI": "Elfenbeinküste",
      "HR": "Kroatien",
      "CU": "Kuba",
      "CW": "Curaçao",
      "CY": "Zypern",
      "CZ": "Tschechien",
      "DK": "Dänemark",
      "DJ": "Dschibuti",
      "DM": "Dominica",
      "DO": "Dominikanische Republik",
      "EC": "Ecuador",
      "EG": "Ägypten",
      "SV": "El Salvador",
      "GQ": "Äquatorialguinea",
      "ER": "Eritrea",
      "EE": "Estland",
      "SZ": "Eswatini",
      "ET": "Äthiopien",
      "FK": "Falklandinseln",
      "FO": "Färöer",
      "FJ": "Fidschi",
      "FI": "Finnland",
      "FR": "Frankreich",
      "GF": "Französisch-Guayana",
      "PF": "Französisch-Polynesien",
      "GA": "Gabun",
      "GM": "Gambia",
      "GE": "Georgien",
      "DE": "Deutschland",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GR": "Griechenland",
      "GL": "Grönland",
      "GD": "Grenada",
      "GP": "Guadeloupe",
      "GU": "Guam",
      "GT": "Guatemala",
      "GN": "Guinea",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HT": "Haiti",
      "HN": "Honduras",
      "HK": "Hongkong",
      "HU": "Ungarn",
      "IS": "Island",
      "IN": "Indien",
      "ID": "Indonesien",
      "IR": "Iran",
      "IQ": "Irak",
      "IE": "Irland",
      "IL": "Israel",
      "IT": "Italien",
      "JM": "Jamaika",
      "JP": "Japan",
      "JO": "Jordanien",
      "KZ": "Kasachstan",
      "KE": "Kenia",
      "KI": "Kiribati",
      "XK": "Kosovo",
      "KW": "Kuwait",
      "KG": "Kirgisistan",
      "LA": "Laos",
      "LV": "Lettland",
      "LB": "Libanon",
      "LS": "Lesotho",
      "LR": "Liberia",
      "LY": "Libyen",
      "LI": "Liechtenstein",
      "LT": "Litauen",
      "LU": "Luxemburg",
      "MO": "Macao",
      "MG": "Madagaskar",
      "MW": "Malawi",
      "MY": "Malaysia",
      "MV": "Malediven",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "Marshallinseln",
      "MQ": "Martinique",
      "MR": "Mauretanien",
      "MU": "Mauritius",
      "MX": "Mexiko",
      "FM": "Mikronesien",
      "MD": "Moldawien",
      "MC": "Monaco",
      "MN": "Mongolei",
      "ME": "Montenegro",
      "MS": "Montserrat",
      "MA": "Marokko",
      "MZ": "Mosambik",
      "MM": "Myanmar",
      "NA": "Namibia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NL": "Niederlande",
      "NC": "Neukaledonien",
      "NZ": "Neuseeland",
      "NI": "Nicaragua",
      "NE": "Niger",
      "NG": "Nigeria",
      "NU": "Niue",
      "NF": "Norfolkinsel",
      "KP": "Nordkorea",
      "MK": "Nordmazedonien",
      "MP": "Nördliche Marianen",
      "NO": "Norwegen",
      "OM": "Oman",
      "PK": "Pakistan",
      "PW": "Palau",
      "PS": "Palästina",
      "PA": "Panama",
      "PG": "Papua-Neuguinea",
      "PY": "Paraguay",
      "PE": "Peru",
      "PH": "Philippinen",
      "PL": "Polen",
      "PT": "Portugal",
      "PR": "Puerto Rico",
      "QA": "Katar",
      "RE": "Réunion",
      "RO": "Rumänien",
      "RU": "Russland",
      "RW": "Ruanda",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "São Tomé und Príncipe",
      "SA": "Saudi-Arabien",
      "SN": "Senegal",
      "RS": "Serbien",
      "SC": "Seychellen",
      "SL": "Sierra Leone",
      "SG": "Singapur",
      "SX": "Sint Maarten",
      "SK": "Slowakei",
      "SI": "Slowenien",
      "SB": "Salomonen",
      "SO": "Somalia",
      "ZA": "Südafrika",
      "KR": "Südkorea",
      "SS": "Südsudan",
      "ES": "Spanien",
      "LK": "Sri Lanka",
      "BL": "Saint-Barthélemy",
      "SH": "St. Helena",
      "KN": "St. Kitts und Nevis",
      "LC": "St. Lucia",
      "MF": "St. Martin",
      "PM": "St. Pierre und Miquelon",
      "VC": "St. Vincent und die Grenadinen",
      "SD": "Sudan",
      "SR": "Suriname",
      "SE": "Schweden",
      "CH": "Schweiz",
      "SY": "Syrien",
      "TW": "Taiwan",
      "TJ": "Tadschikistan",
      "TZ": "Tansania",
      "TH": "Thailand",
      "TL": "Osttimor",
      "TG": "Togo",
      "TK": "Tokelau",
      "TO": "Tonga",
      "TT": "Trinidad und Tobago",
      "TN": "Tunesien",
      "TR": "Türkei",
      "TM": "Turkmenistan",
      "TC": "Turks- und Caicosinseln",
      "TV": "Tuvalu",
      "VI": "Amerikanische Jungferninseln",
      "UG": "Uganda",
      "UA": "Ukraine",
      "AE": "Vereinigte Arabische Emirate",
      "GB": "Vereinigtes Königreich",
      "US": "Vereinigte Staaten",
      "UY": "Uruguay",
      "UZ": "Usbekistan",
      "VU": "Vanuatu",
      "VA": "Vatikanstadt",
      "VE": "Venezuela",
      "VN": "Vietnam",
      "WF": "Wallis und Futuna",
      "YE": "Jemen",
      "ZM": "Sambia",
      "ZW": "Simbabwe"
    }
  },
  "validation": {
    "accepted": ":attribute muss akzeptiert werden.",
    "active_url": ":attribute ist keine gültige Internet-Adresse.",
    "after": ":attribute muss ein Datum nach :date sein.",
    "after_or_equal": ":attribute muss ein Datum nach :date oder gleich :date sein.",
    "alpha": ":attribute darf nur aus Buchstaben bestehen.",
    "alpha_dash": ":attribute darf nur aus Buchstaben, Zahlen, Binde- und Unterstrichen bestehen.",
    "alpha_num": ":attribute darf nur aus Buchstaben und Zahlen bestehen.",
    "array": ":attribute muss ein Array sein.",
    "before": ":attribute muss ein Datum vor :date sein.",
    "before_or_equal": ":attribute muss ein Datum vor :date oder gleich :date sein.",
    "between": {
      "numeric": ":attribute muss zwischen :min & :max liegen.",
      "file": ":attribute muss zwischen :min & :max Kilobytes groß sein.",
      "string": ":attribute muss zwischen :min & :max Zeichen lang sein.",
      "array": ":attribute muss zwischen :min & :max Elemente haben."
    },
    "boolean": ":attribute muss entweder true oder false sein.",
    "captcha": "Please verify that you are not a robot.",
    "completed": "Please fill in a valid phone number.",
    "confirmed": ":attribute stimmt nicht mit der Bestätigung überein.",
    "date": ":attribute muss ein gültiges Datum sein.",
    "date_format": ":attribute entspricht nicht dem gültigen Format für :format.",
    "date_equals": ":attribute muss ein Datum gleich :date sein.",
    "different": ":attribute und :other müssen sich unterscheiden.",
    "digits": ":attribute muss :digits Stellen haben.",
    "digits_between": ":attribute muss zwischen :min und :max Stellen haben.",
    "dimensions": ":attribute hat ungültige Bildabmessungen.",
    "distinct": ":attribute beinhaltet einen bereits vorhandenen Wert.",
    "email": ":attribute muss eine gültige E-Mail-Adresse sein.",
    "exists": "Der gewählte Wert für :attribute ist ungültig.",
    "file": ":attribute muss eine Datei sein.",
    "filled": ":attribute muss ausgefüllt sein.",
    "gt": {
      "numeric": ":attribute muss größer als :value sein.",
      "file": ":attribute muss größer als :value Kilobytes sein.",
      "string": ":attribute muss länger als :value Zeichen sein.",
      "array": ":attribute muss mehr als :value Elemente haben."
    },
    "gte": {
      "numeric": ":attribute muss größer oder gleich :value sein.",
      "file": ":attribute muss größer oder gleich :value Kilobytes sein.",
      "string": ":attribute muss mindestens :value Zeichen lang sein.",
      "array": ":attribute muss mindestens :value Elemente haben."
    },
    "image": ":attribute muss ein Bild sein.",
    "in": "Der gewählte Wert für :attribute ist ungültig.",
    "in_array": "Der gewählte Wert für :attribute kommt nicht in :other vor.",
    "integer": ":attribute muss eine ganze Zahl sein.",
    "ip": ":attribute muss eine gültige IP-Adresse sein.",
    "ipv4": ":attribute muss eine gültige IPv4-Adresse sein.",
    "ipv6": ":attribute muss eine gültige IPv6-Adresse sein.",
    "json": ":attribute muss ein gültiger JSON-String sein.",
    "lt": {
      "numeric": ":attribute muss kleiner als :value sein.",
      "file": ":attribute muss kleiner als :value Kilobytes sein.",
      "string": ":attribute muss kürzer als :value Zeichen sein.",
      "array": ":attribute muss weniger als :value Elemente haben."
    },
    "lte": {
      "numeric": ":attribute muss kleiner oder gleich :value sein.",
      "file": ":attribute muss kleiner oder gleich :value Kilobytes sein.",
      "string": ":attribute darf maximal :value Zeichen lang sein.",
      "array": ":attribute darf maximal :value Elemente haben."
    },
    "max": {
      "numeric": ":attribute darf maximal :max sein.",
      "file": ":attribute darf maximal :max Kilobytes groß sein.",
      "string": ":attribute darf maximal :max Zeichen haben.",
      "array": ":attribute darf maximal :max Elemente haben."
    },
    "mimes": ":attribute muss den Dateityp :values haben.",
    "mimetypes": ":attribute muss den Dateityp :values haben.",
    "min": {
      "numeric": ":attribute muss mindestens :min sein.",
      "file": ":attribute muss mindestens :min Kilobytes groß sein.",
      "string": ":attribute muss mindestens :min Zeichen lang sein.",
      "array": ":attribute muss mindestens :min Elemente haben."
    },
    "not_in": "Der gewählte Wert für :attribute ist ungültig.",
    "not_regex": ":attribute hat ein ungültiges Format.",
    "numeric": ":attribute muss eine Zahl sein.",
    "present": ":attribute muss vorhanden sein.",
    "regex": ":attribute Format ist ungültig.",
    "required": ":attribute muss ausgefüllt werden.",
    "required_if": ":attribute muss ausgefüllt werden, wenn :other den Wert :value hat.",
    "required_unless": ":attribute muss ausgefüllt werden, wenn :other nicht den Wert :values hat.",
    "required_with": ":attribute muss ausgefüllt werden, wenn :values ausgefüllt wurde.",
    "required_with_all": ":attribute muss ausgefüllt werden, wenn :values ausgefüllt wurde.",
    "required_without": ":attribute muss ausgefüllt werden, wenn :values nicht ausgefüllt wurde.",
    "required_without_all": ":attribute muss ausgefüllt werden, wenn keines der Felder :values ausgefüllt wurde.",
    "same": ":attribute und :other müssen übereinstimmen.",
    "size": {
      "numeric": ":attribute muss gleich :size sein.",
      "file": ":attribute muss :size Kilobyte groß sein.",
      "string": ":attribute muss :size Zeichen lang sein.",
      "array": ":attribute muss genau :size Elemente haben."
    },
    "string": ":attribute muss ein String sein.",
    "timezone": ":attribute muss eine gültige Zeitzone sein.",
    "unique": ":attribute ist bereits vergeben.",
    "uploaded": ":attribute konnte nicht hochgeladen werden.",
    "url": ":attribute muss eine URL sein.",
    "uuid": ":attribute muss ein UUID sein.",
    "remote": "Das Feld :attribute ist ungültig."
  }
}